import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import CustomChatbotIcons from "./CustomChatbotIcons";
import {
  Button,
  Modal,
  Box,
  Stack,
  InputLabel,
  Input,
  TextField,
} from "@mui/material";
import SuperAppButton from "./SuperAppButton";

function DrawMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [modelOpen, setModelOpen] = useState(false);
  const [iconName, setIconName] = useState(null);

  const data = props?.field;
  const sample_type = data?.sample_type;
  const iconData = props?.iconData;

  const handleMenuSelect = (e, value, field) => {
    if (e) {
      e.preventDefault();
    }

    props.setFormData({
      data: { ...props.data, [field]: value },
      status: "IDLE",
    });

    setAnchorEl(null);
  };

  const handleMenuClick = (event) => {
    if (anchorEl === null) setAnchorEl(event.currentTarget);
    else setAnchorEl(null);
  };

  const onChangeData = (data) => {
    setModelOpen(false);
    props.setFormData({
      data: {
        ...props.data,
        [props.field.name]: iconName,
        agent_icon_configuration: data,
      },
      status: "IDLE",
    });

    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <button
          type="button"
          className="small-primary-btn"
          aria-controls="simple-menu"
          aria-haspopup="true"
          style={{
            cursor: "pointer",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
          onClick={handleMenuClick}
        >
          Show/Hide Samples
        </button>
      </div>

      <Menu
        keepMounted
        disableScrollLock={true}
        anchorEl={anchorEl}
        onClose={handleMenuClick}
        open={Boolean(anchorEl)}
      >
        {props.field.samples.map((sample) => {
          return (
            <MenuItem
              sx={{
                whiteSpace: "normal",
                alignItems: "center",
                justifyContent: "center",
              }}
              key={sample}
              onClick={(e) => {
                e.isPropagationStopped();
                if (sample.startsWith("https://") || !sample_type) {
                  handleMenuSelect(e, sample, props.field.name);
                }
              }}
            >
              {sample.startsWith("https://") && (
                <img alt={sample} src={sample}></img>
              )}
              {!sample_type && !sample.startsWith("https://") && sample}

              {sample_type && sample_type === "custom_icon" && (
                <>
                  <span
                    onClick={() => {
                      setModelOpen(true);
                      setIconName(sample);
                    }}
                  >
                    <CustomChatbotIcons name={sample} />
                  </span>
                </>
              )}
            </MenuItem>
          );
        })}
      </Menu>

      {iconName && sample_type && sample_type === "custom_icon" && (
        <>
          {modelOpen && (
            <ColorPickerModal
              isOpen={modelOpen}
              onClose={() => setModelOpen(false)}
              onConfirm={onChangeData}
              name={iconName}
              iconData={iconData}
            />
          )}
        </>
      )}
    </>
  );
}

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#202345",
  color: "white",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
};

const ColorPickerModal = ({ isOpen, onClose, onConfirm, name, iconData }) => {
  const [color, setColor] = useState(iconData?.color || "#000000");
  const [secondaryColor, setSecondaryColor] = useState(
    iconData?.secondaryColor || "#666666"
  ); /* Added secondaryColor state. Vik APR 16, 2025 */
  const [tertiaryColor, setTertiaryColor] = useState(
    iconData?.tertiaryColor || "#000000"
  ); /* Added tertiaryColor state. Vik APR 17, 2025 */
  const [width, setWidth] = useState(iconData?.width || 100);
  const [height, setHeight] = useState(iconData?.height || 100);

  const handleChange = (type, value) => {
    if (type === "color") setColor(value);
    else if (type === "secondaryColor") setSecondaryColor(value);
    /* Added secondaryColor handler. Vik APR 16, 2025 */ else if (
      type === "tertiaryColor"
    )
      setTertiaryColor(value);
    /* Added tertiaryColor handler. Vik APR 17, 2025 */ else if (
      type === "width"
    )
      setWidth(value);
    else if (type === "height") setHeight(value);
  };

  const handleConfirm = () => {
    onConfirm({
      color,
      secondaryColor,
      tertiaryColor,
      width,
      height,
    }); /* Include secondaryColor in confirm data. Vik APR 16, 2025 */
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="color-picker-modal-title"
      aria-describedby="color-picker-modal-description"
    >
      <Box sx={modalStyle}>
        <Stack
          direction="row"
          spacing={4}
          justifyContent="space-between"
          alignItems="flex-start"
        >
          {/* First Column: Color Pickers */}
          <Stack spacing={3} sx={{ width: "40%" }}>
            <Stack spacing={1}>
              <InputLabel sx={{ color: "white" }}>Primary Color</InputLabel>
              <Input
                type="color"
                value={color}
                onChange={(e) => handleChange("color", e.target.value)}
                disableUnderline
                sx={{
                  width: 60,
                  height: 40,
                  bgcolor: "#1E293B",
                  borderRadius: 1,
                  border: "2px solid white",
                  cursor: "pointer",
                }}
              />
            </Stack>
            <Stack spacing={1}>
              <InputLabel sx={{ color: "white" }}>Secondary Color</InputLabel>
              <Input
                type="color"
                value={secondaryColor}
                onChange={(e) => handleChange("secondaryColor", e.target.value)}
                disableUnderline
                sx={{
                  width: 60,
                  height: 40,
                  bgcolor: "#1E293B",
                  borderRadius: 1,
                  border: "2px solid white",
                  cursor: "pointer",
                }}
              />
            </Stack>
            {/* <Stack spacing={1}>
              <InputLabel sx={{ color: "white" }}>Tertiary Color</InputLabel>
              <Input
                type="color"
                value={tertiaryColor}
                onChange={(e) => handleChange("tertiaryColor", e.target.value)}
                disableUnderline
                sx={{
                  width: 60,
                  height: 40,
                  bgcolor: "#1E293B",
                  borderRadius: 1,
                  border: "2px solid white",
                  cursor: "pointer",
                }}
              />
            </Stack> */}
          </Stack>

          {/* Second Column: Icon Preview and Dimensions */}
          <Stack spacing={3} sx={{ width: "60%", alignItems: "center" }}>
            <Box sx={{ textAlign: "center", my: 2 }}>
              <CustomChatbotIcons
                name={name}
                color={color}
                secondaryColor={secondaryColor}
                // tertiaryColor={tertiaryColor}
                width={width}
                height={height}
              />
            </Box>
            <Stack direction="row" spacing={2}>
              <TextField
                label="Width"
                type="number"
                value={width}
                onChange={(e) => handleChange("width", e.target.value)}
                variant="outlined"
                InputLabelProps={{ style: { color: "white" } }}
                sx={{ minWidth: 120 }}
              />
              <TextField
                label="Height"
                type="number"
                value={height}
                onChange={(e) => handleChange("height", e.target.value)}
                variant="outlined"
                InputLabelProps={{ style: { color: "white" } }}
                sx={{ minWidth: 120 }}
              />
            </Stack>
          </Stack>
        </Stack>

        <Box display="flex" justifyContent="space-between" mt={4}>
          <SuperAppButton
            className="primary-gradient-btn"
            onClick={handleConfirm}
          >
            Save
          </SuperAppButton>
          <SuperAppButton
            className="transparent-bg-white-btn"
            onClick={onClose}
          >
            Cancel
          </SuperAppButton>
        </Box>
      </Box>
    </Modal>
  );
};

export default DrawMenu;
